import React, { useContext } from 'react'
import classnames from 'classnames'
import styles from './index.module.less'

import context from '../../context'
import { IState } from '@/components/poizon-fission/types'

function OneNarrate(props: { account: string } & IState) {
  const { account, flow } = props
  return (
    <div className={classnames(styles.narrate, styles.one)}>
      <span className={classnames(styles.icon, styles[flow])}></span>
      <span className={classnames(styles.explain, styles[flow])}>{account}</span>
    </div>
  )
}

function TwoNarrate(props: { purchase: string } & IState) {
  const { purchase, flow } = props
  return (
    <div className={classnames(styles.narrate, styles.two)}>
      <span className={classnames(styles.icon, styles[flow])}></span>
      <span className={classnames(styles.explain, styles[flow])}>{purchase}</span>
    </div>
  )
}

function ThreeNarrate(props: { sale: string; create: string } & IState) {
  const { sale, create, flow } = props
  return (
    <div className={styles.narrateSpecial}>
      <div className={styles.narrate} style={{ flex: 1 }}>
        <span className={classnames(styles.icon, styles[flow])}></span>
        <span className={classnames(styles.explain, styles[flow])}>{sale}</span>
      </div>
      <div className={styles.narrate} style={{ flex: 1 }}>
        <span className={classnames(styles.icon, styles[flow])}></span>
        <span className={classnames(styles.explain, styles[flow])}>{create}</span>
      </div>
    </div>
  )
}

export default function Narrate(props: { steps: string } & IState) {
  const {
    advantage: { account, purchase, sale, create },
  } = useContext(context)
  const { steps, flow } = props

  if (steps === 'one') {
    return <OneNarrate account={account} flow={flow} />
  }

  if (steps === 'two') {
    return <TwoNarrate purchase={purchase} flow={flow} />
  }

  if (steps === 'three') {
    return <ThreeNarrate sale={sale} create={create} flow={flow} />
  }
  return <></>
}
